import {curry} from "ramda";


// Dom traversing
export const find = selector => findIn(selector, document);
export const findAll = selector => findAllIn(selector, document);
export const findIn = curry((selector, element) => element.querySelector(selector));
export const findAllIn = curry((selector, element) => toArray(element.querySelectorAll(selector)));

// todo add polyfill
export const closest = curry((selector, element) => element.closest(selector));

//Dom manipulation
export const setText = curry((text, element) => element.textContent = text);
export const empty = element => element.textContent = '';

// Class manipulation
export const addClass = curry((className, element) => {
    element.classList.add(className);
    return element;
});
export const removeClass = curry((className, element) => {
    element.classList.remove(className);
    return element;
});
export const toggleClass = curry((className, element) => {
    element.classList.toggle(className);
    return element;
});
export const hasClass = curry((className, element) => element.classList.contains(className));
export const is = curry((selector, element) => element.closest(selector));

// Attributes
export const setAttribute = curry((name, value, element) => element.setAttribute(name, value));
export const removeAttribute = curry((name, element) => element.removeAttribute(name));

// Events
export const on = curry((eventType, fnc, element) => {
    element.addEventListener(eventType, fnc);
    return element;
});

export const off = curry((eventType, fnc, element) => {
    element.removeEventListener(eventType, fnc);
    return element;
});

export const trigger = curry((eventType, element) => {
    // todo ie10
    element.dispatchEvent(new Event(eventType, {bubbles: true}));
    return element;
});

// Misc
export const toHTMLElementArray = x => {
    if (NodeList.prototype.isPrototypeOf(x)) {
        return Array.from(x);
    } else if (Array.isArray(x)) {
        return x;
    } else {
        return [x];
    }
};

// private helper
const toArray = iterable => Array.from(iterable);
